<template>
  <div>
    <div v-if="title" class="content_title content_700 mb-24">
      {{ title }}
    </div>
    <div class="content_18 mb-48">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentSection',
  props: {
    title: {
      type: String,
      default() {
        return null
      }
    }
  }
}
</script>
